<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 5; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div
        v-if="!LoaderStatus"
        class="
          asc-page-heading
          d-flex
          justify-content-between
          align-items-center
        "
      >
        <span>Dashboard</span>
      </div>

      <div class="graph-main-container" v-if="showCards && !LoaderStatus">
        <div class="d-flex w-100">
          <ThirdPartyUsage
            v-if="roles.includes('GET_THIRD_PARTY') && leadKey !== null"
            :leadKey="leadKey"
          />
          <!-- View Thrid Party -->
          <RoleDistribution
            v-if="roles.includes('GET_ROLE') && leadKey !== null"
            :leadKey="leadKey"
          />
          <!-- View Roles -->
        </div>
        <div v-if="roles.includes('VIEW_ADMIN') && leadKey !== null">
          <LicenseUsage :leadKey="leadKey" />

          <!-- v-if="roles.includes('VIEW_ADMIN')" -->
        </div>
        <div class="d-flex w-100">
          <CustomerReport
            v-if="roles.includes('PUSH_JOB') && leadKey !== null"
            :leadKey="leadKey"
          />
          <!-- v-if="roles.includes('PUSH_JOB')" -->
          <JobAlert
            :leadKey="leadKey"
            v-if="roles.includes('PUSH_JOB') && leadKey !== null"
          />

          <!-- GET_JOBDASHBOARD/PUSH_JOB -->
        </div>
        <div
          v-if="
            (roles.includes('PUSH_JOB') && leadKey !== null) ||
            (roles.includes('GET_JOBDASHBOARD') && leadKey !== null)
          "
        >
          <ScheduleInterview :leadKey="leadKey" />
        </div>

        <!-- v-if="roles.includes('PUSH_JOB')" -->
        <!-- JOB -->
        <!-- </div> -->
        <div
          class="d-flex w-100"
          v-if="
            (roles.includes('PUSH_JOB') && leadKey !== null) ||
            (roles.includes('GET_JOBDASHBOARD') && leadKey !== null)
          "
        >
          <RecentlySelectedCand :leadKey="leadKey" />
          <SelectionRateStats :leadKey="leadKey" />
        </div>
        <div class="d-flex w-100" v-if="leadKey !== null">
          <RecruiterReport v-if="leadKey" />
          <JobAlert
            :leadKey="leadKey"
            v-if="roles.includes('GET_JOBDASHBOARD') && !leadKey"
          />
          <VendorReport
            :leadKey="leadKey"
            v-if="
              roles.includes('PUSH_JOB') || roles.includes('GET_JOBDASHBOARD')
            "
          />
        </div>
        <div
          v-if="
            (roles.includes('PUSH_JOB') && leadKey !== null) ||
            (roles.includes('GET_JOBDASHBOARD') && leadKey !== null)
          "
        >
          <PendingCandFeedback :leadKey="leadKey" />
        </div>
      </div>

      <div
        class="mt-3 dashboardAdmin-main-container bluebtn"
        v-else-if="!showCards && !LoaderStatus"
      >
        <div class="dashboardAdmin-inner-container d-flex w-100">
          <div style="width: 70%">
            <div class="dashboardAdmin-inner-container-head mt-3">
              Hello, {{ roleValues.username }}
            </div>
            <div class="mt-3 dashboardAdmin-inner-container-subhead">
              Welcome to Hire3x Recruitment platform
            </div>

            <div
              class="dashboardAdmin-inner-container-inner-subhead change-width"
            >
              Start streamlining your entire hiring process, optimize your
              recruitment journey with all-in-one convenient solution
            </div>
          </div>
          <div>
            <img
              src="../../assets/New-imgs/landing-dashboard/dashboardcard-man-img.svg"
              alt=""
            />
          </div>
        </div>
        <div
          class="
            dashboardAdmin-inner-container
            w-100
            d-flex
            justify-content-center
            flex-column
            dashboardAdmin-check-marginTop
          "
        >
          <div class="w-100 row">
            <div
              v-for="(card, index) in cardsData"
              :key="index"
              class="w-50 col-6"
              :class="[
                index == 0 || index == 1 ? 'mb-4' : '',
                card.completed ? 'pointer' : '',
              ]"
              @click="card.completed ? $router.push({ path: card.route }) : ''"
            >
              <div class="dashboardAdmin-cards d-flex justify-content-between">
                <div
                  class="d-flex dashboardAdmin-cards-leftside"
                  :class="
                    card.completed
                      ? 'dashboardAdmin-cards-leftside'
                      : !card.completed
                      ? 'dashboardAdmin-cards-leftside-forDropdown'
                      : card.button === 'Search' || card.button === 'User'
                      ? 'dashboardAdmin-cards-leftside-forBtn'
                      : ''
                  "
                >
                  <div>
                    <img :src="card.image" alt="" />
                  </div>

                  <div class="ml-3">
                    <div class="dashboardAdmin-cards-head">
                      {{ card.title }}
                    </div>
                    <div class="dashboardAdmin-cards-subhead mt-2">
                      {{ card.description }}
                    </div>
                  </div>
                </div>

                <div
                  class="
                    dashboardAdmin-cards-rightside
                    position-relative
                    d-flex
                    align-items-center
                    justify-content-center
                  "
                  :class="
                    card.completed
                      ? 'dashboardAdmin-cards-rightside'
                      : !card.completed
                      ? 'dashboardAdmin-cards-rightside-forDropdown'
                      : card.button === 'Search' || card.button === 'User'
                      ? 'dashboardAdmin-cards-rightside-forBtn'
                      : ''
                  "
                >
                  <div v-if="card.button === 'Search'" class="bluebtn w-100">
                    <b-button
                      class="
                        dashboardAdmin-addBtn-modal
                        d-flex
                        align-items-center
                        justify-content-center
                        w-100
                      "
                      @click="$router.push({ path: card.route })"
                    >
                      <img
                        src="../../assets/New-imgs/landing-dashboard/search-img.svg"
                        alt=""
                        class="mr-2"
                      />{{ card.button }}
                    </b-button>
                  </div>
                  <div
                    v-else-if="card.completed"
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                    "
                  >
                    <div>
                      <img
                        src="../../assets/New-imgs/landing-dashboard/created-img.svg"
                        alt=""
                      />
                      <span class="dasboardAdmin-created-font"> Created </span>
                    </div>
                    <div>
                      <img
                        src="../../assets/New-imgs/landing-dashboard/dashboard-right-arrow.svg"
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    refs="customerDropdown"
                    v-closable="{
                      exclude: ['customerDropdown'],
                      handler: 'hidecustomerDropdown',
                    }"
                    v-else-if="
                      card.title == 'Create Job' &&
                      card.customers &&
                      card.customers.length != 0
                    "
                    class="
                      d-flex
                      align-items-center
                      justify-content-between
                      w-100
                      pointer
                    "
                  >
                    <div>
                      <div
                        @click="sortcard = !sortcard"
                        class="
                          acs-filter-dropdown acs-filter-dropdown-width
                          position-relative
                          pointer
                        "
                      >
                        <span
                          class="
                            acs-filter-dropdown-place
                            acs-filter-dropdown-place-text
                          "
                        >
                          {{ selectedCustomerName }}
                        </span>
                        <img
                          class="ml-2"
                          src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                          alt=""
                        />
                      </div>
                      <div v-if="sortcard" class="relativeclass">
                        <div class="newInt-radio-dropdown height-dropdown p-0">
                          <b-form-group class="sec-mcq-datacard">
                            <b-form-radio-group
                              class="newInt-radio-dropdown-inner-content w-100"
                              size="sm"
                              v-model="sort_selected"
                              :options="card.customers"
                              :text-field="'name'"
                              :value-field="'customerID'"
                              @change="sortcard = false"
                              buttons
                              stacked
                            >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>
                      </div>
                    </div>
                    <div>
                      <img
                        src="../../assets/New-imgs/landing-dashboard/dashboard-right-arrow.svg"
                        alt=""
                        @click="goToInternalHiringDashboard"
                      />
                    </div>
                  </div>
                  <div v-else class="w-100">
                    <b-button
                      class="
                        dashboardAdmin-addBtn-modal
                        d-flex
                        align-items-center
                        justify-content-center
                        w-100
                      "
                      @click="$router.push({ path: card.route })"
                    >
                      <img
                        src="../../assets/New-imgs/landing-dashboard/add-img.svg"
                        alt=""
                        class="mr-2"
                      />
                      <span> {{ card.button }} </span>
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import Spinner from "../../components/fixedcomponents/Spinner.vue";

import { getCards, getLeadStatus } from "../../utils/apiFunctions";
import ThirdPartyUsage from "../../components/MainDashboard/ThirdPartyUsage.vue";
import RoleDistribution from "../../components/MainDashboard/RoleDistribution.vue";
import LicenseUsage from "../../components/MainDashboard/LicenseUsage.vue";
import CustomerReport from "../../components/MainDashboard/CustomerReport.vue";
// import JobAlert from "../../components/MainDashboard/JobAlert.vue";
import ScheduleInterview from "../../components/MainDashboard/ScheduleInterview.vue";
import RecentlySelectedCand from "../../components/MainDashboard/RecentlySelectedCand.vue";
import SelectionRateStats from "../../components/MainDashboard/SelectionRateStats.vue";
import RecruiterReport from "../../components/MainDashboard/RecruiterReport.vue";
import VendorReport from "../../components/MainDashboard/VendorReport.vue";
import PendingCandFeedback from "../../components/MainDashboard/PendingCandFeedback.vue";

export default {
  name: "MainDashboard",
  data() {
    return {
      // ARRAYS
      cardsData: [],
      sort_selected: "Select Customer",
      sortcard: false,
      showAllComp: false,
      LoaderStatus: false,
      showCards: false,
      leadKey: null,
    };
  },
  components: {
    Spinner,

    ThirdPartyUsage,
    RoleDistribution,
    LicenseUsage,
    CustomerReport,
    // JobAlert,
    ScheduleInterview,
    RecentlySelectedCand,
    SelectionRateStats,
    RecruiterReport,
    VendorReport,
    PendingCandFeedback,
  },
  computed: {
    ...mapGetters(["roles"]),
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
    selectedCustomerName() {
      for (const card of this.cardsData) {
        if (card.customers) {
          const selectedCustomer = card.customers.find(
            (customer) => customer.customerID === this.sort_selected
          );
          if (selectedCustomer) {
            return selectedCustomer.name;
          }
        }
      }
      return "Select a Customer";
    },
  },
  created() {
    this.LoaderStatus = true;
    this.getLead();
    this.getCardsData();
  },
  methods: {
    async getLead() {
      try {
        const res = await getLeadStatus();
        this.leadKey = res.data.data.lead;
        this.$forceUpdate();
      } catch (error) {
        console.error(error);
      }
    },

    ...mapMutations("jobDescriptionVUEX", {
      saveCustomerDetail: "saveCustomerDetail",
    }),
    goToInternalHiringDashboard() {
      const { selectedCustomerName, sort_selected } = this;

      if (selectedCustomerName !== "Select a Customer") {
        this.saveCustomerDetail({
          name: selectedCustomerName,
          customerID: sort_selected,
          lead: true,
        });
        this.$router.push({
          name: "InternalHiringDashboard",
          params: {
            cardName: selectedCustomerName,
            customerID: sort_selected,
          },
        });
      }
    },
    hidecustomerDropdown() {
      this.sortcard = false;
    },
    async getCardsData() {
      try {
        const payload = {
          userID: this.roleValues.userID,
        };
        const response = await getCards(payload);
        if (response.status == 200) {
          this.LoaderStatus = false;
        }
        this.cardsData = response.data.data.cards;
        this.showCards = this.cardsData
          .filter(
            (card) =>
              !["/search/profiles", "/thirdparty/home"].includes(card.route)
          )
          .every((card) => card.completed === true);
      } catch (error) {
        console.error("Error:", error);
      }
    },
  },
};
</script>

<style>
.acs-filter-dropdown-place-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: calc(100% - 20px);
}

.acs-filter-dropdown-width {
  width: 160px;
}

.height-dropdown {
  max-height: 164px;
  overflow-x: hidden;
  overflow-y: auto;
  min-height: auto;
}
</style>
